import { sideBar, navBar, tagView, setting, horizontalSide } from './components';
import backTop from '@/components/backTop/index';
import { mapState } from 'vuex';
import { systemConfigResourse } from '@/views/system/settings/request.js';
import { LANGUAGE_RESOURCE } from '@/utils/public';
import message from './components/message/index';
import forceReaderingMessageModel from './components/message/forceReaderingMessageModel.vue';
import noticeUploadInsuranceTemplate from './components/message/noticeUploadInsuranceTemplate.vue';
export default {
  name: 'layout',
  components: {
    sideBar,
    navBar,
    tagView,
    setting,
    backTop,
    horizontalSide,
    message,
    forceReaderingMessageModel,
    noticeUploadInsuranceTemplate
  },
  data() {
    return {
      contactWay: {}
    };
  },
  computed: {
    ...mapState({
      open: state => state.setting.open,
      fixHeader: state => state.setting.fixHeader,
      tagShow: state => state.setting.tagShow,
      layout: state => state.setting.layout,
      accountInfo: state => state.user.accountInfo
    }),
    horizontal() {
      return this.layout == 'horizontal';
    },
    key() {
      return this.$route.path;
    },
    language() {
      return LANGUAGE_RESOURCE[this.$store.state.setting.locale];
    }
  },
  mounted() {
    if (this.accountInfo.customerId > 0) {
      this.getSystemConfig();
    }
  },
  watch: {
    // 监听语言变化
    '$store.state.setting.locale': {
      handler: function (val, oldVal) {
        if (this.accountInfo.customerId > 0) {
          this.getSystemConfig();
        }
      },
      deep: true
    }
  },
  methods: {
    changeVisivle() {
      this.$store.dispatch('setting/changeVisible', true);
    },
    async getSystemConfig() {
      let res = await systemConfigResourse({
        type: '0'
      });
      console.log(res, '---------res systemConfigResourse----------');
      // 联系方式
      const contactWay = res[1];
      if (!contactWay[this.language]) {
        if (process.env.VUE_APP_BASE_API.includes('console.insureforce.cn')) {
          // 国内-中文
          this.contactWay = contactWay['zh'];
        } else {
          // 海外-英文
          this.contactWay = contactWay['en'];
        }
      } else {
        this.contactWay = contactWay[this.language];
      }
    }
  }
};